import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./i18n.ts";
import App from "./App";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./apollo/apolloClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ApolloProvider client={apolloClient}>
    <App />
  </ApolloProvider>
);
